const EnvConstant = {
    FORM_BASE_URL: 'REACT_APP_FORM_BASE_URL',
    FORM_SUBMIT_BASE_URL: 'REACT_APP_FORM_SUBMIT_BASE_URL',
    API_PAYOUT_URL: 'REACT_APP_API_PAYOUT_URL'
}
export default EnvConstant;